import useSWRMutation from 'swr/mutation';
import { DUpdateCustomerLastSeen } from '../data/dtos/last-seen';
import { marketplaceChatService } from '../services/marketplace';

export function useUpdateMarketplaceCustomerLastSeen({
  userId,
  conversationId,
}: Nullable<DUpdateCustomerLastSeen>) {
  const execute = async () => {
    return await marketplaceChatService.updateCustomerLastSeen({
      userId: userId!,
      conversationId: conversationId!,
    });
  };

  const fetchKey =
    userId && conversationId
      ? ['update-marketplace-customer-last-seen', userId, conversationId]
      : null;
  const { isMutating, trigger } = useSWRMutation(fetchKey, execute);

  return {
    trigger,
    isLoading: isMutating,
  };
}
